import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  // <svg
  //   width="16"
  //   height="16"
  //   viewBox="0 0 16 16"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <path
  //     d="M15.6832 4.91115C15.4266 4.65453 15.0118 4.65453 14.7552 4.91115L13.2502 6.41607L9.5841 2.74992L11.089 1.245C11.3456 0.988381 11.3456 0.573592 11.089 0.316975C10.8324 0.0603573 10.4176 0.0603573 10.161 0.316975L8.29379 2.18418L4.44584 3.60772C3.46925 3.96934 2.71515 4.78317 2.429 5.7847L0.196884 13.6086C0.0144299 14.2295 0.185071 14.8995 0.643176 15.357C0.979863 15.6943 1.43206 15.8755 1.89279 15.8755C2.05753 15.8755 2.22357 15.8525 2.38568 15.8046L10.1853 13.5882C11.1835 13.3047 11.9967 12.5552 12.3609 11.5839L13.8147 7.70703L15.6825 5.83917C15.9392 5.58256 15.9392 5.16777 15.6825 4.91115H15.6832ZM11.1317 11.1231C10.9131 11.7059 10.4255 12.1555 9.82627 12.3261L2.5281 14.4001L6.34652 10.5817C6.45481 10.6106 6.569 10.6263 6.68648 10.6263C7.41171 10.6263 7.99911 10.0389 7.99911 9.31368C7.99911 8.58846 7.41171 8.00106 6.68648 8.00106C5.96126 8.00106 5.37386 8.58846 5.37386 9.31368C5.37386 9.43116 5.38962 9.54536 5.41849 9.65365L1.60073 13.4714L3.69043 6.14633C3.86238 5.54515 4.31458 5.05685 4.90066 4.83961L8.48871 3.5119L12.4863 7.50948L11.1317 11.1231Z"
  //     className="iconBorder"
  //   />
  // </svg>

  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8282 6.07923L13.4906 7.41681L8.58242 2.50865L9.92 1.17106C10.1481 0.942979 10.5168 0.942979 10.7448 1.17106L14.8282 5.2544C15.0563 5.48248 15.0563 5.85115 14.8282 6.07923ZM7.52658 3.10248L4.84033 4.0959C3.97233 4.41731 3.30208 5.14065 3.04775 6.03081L1.06383 12.9847C0.958833 13.3417 0.985666 13.7162 1.12742 14.047L5.70542 9.46898C5.67975 9.37273 5.66575 9.27123 5.66575 9.16681C5.66575 8.52223 6.18783 8.00015 6.83242 8.00015C7.477 8.00015 7.99908 8.52223 7.99908 9.16681C7.99908 9.8114 7.477 10.3335 6.83242 10.3335C6.728 10.3335 6.6265 10.3195 6.53025 10.2938L1.95225 14.8718C2.14767 14.9558 2.35825 14.9996 2.57117 14.9996C2.71758 14.9996 2.86517 14.9791 3.00925 14.9366L9.94158 12.9666C10.8288 12.7146 11.5516 12.0485 11.8753 11.1851L12.8938 8.46973L7.52658 3.10248Z"
      className="iconBorder"
    />
  </svg>
);

const PenIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default PenIcon;
